{
    "Profile_Menu.IssueQuote": "FR: Issue Quote",
    "Profile_Menu.Issue": "FR: Issue Policy",
    "Profile_Menu.SendPaymentLink": "FR: Send Payment Link",
    "Profile_Menu.ChargeCard": "FR: Charge Card",
    "Profile_Menu.Endorse": "FR: Endorse",
    "Profile_Menu.FinalizeQuote": "FR: Finalize Quote",
    "Profile_Menu.Modal.IssueQuote": "FR: Issue Quote",
    "Profile_Menu.Modal.IssuePolicy": "FR: Issue Policy",
    "Profile_Menu.Modal.SendProposalEmail": "FR: Send Proposal Email",
    "Profile_Menu.Modal.SendPolicyConfirmation": "FR: Send Policy Confirmation",
    "Profile_Menu.Modal.SelectDocuments": "FR: Select documents to attach:",
    "Profile_Menu.Modal.Download": "FR: Download",
    "Profile_Menu.Modal.AddCC": "FR: Add a CC:",
    "Profile_Menu.Modal.AddNote": "FR: Add a note:",
    "Profile_Menu.Modal.EmailInfo": "FR: The insured will receive an email containing any attachment you have included, along with any notes you have added to the notes area above.",
    "Profile_Menu.Modal.Cancel": "FR: Cancel",
    "Profile_Menu.Modal.Issue": "FR: Issue",
    "Profile_Menu.Modal.Confirm": "FR: Confirm",
    "Profile_Menu.Modal.Create": "FR: Create",
    "Profile_Menu.Modal.Submit": "FR: Submit",
    "Profile_Menu.Modal.ConfirmBind": "FR: Confirm Bind",
    "Profile_Menu.Modal.EnterPolicyNumber": "FR: Enter Policy Number",
    "Profile_Menu.Modal.PaymentLinkTitle": "FR: Send Payment Link",
    "Profile_Menu.Modal.PaymentLinkInfo1": "FR: Your customer will receive an email with a link to pay for their policy.",
    "Profile_Menu.Modal.PaymentLinkInfo2": "FR: If successful, the policy will automatically bound and documents will be generated and made available to the insured in Customer portal branded by your brokerage.",
    "Profile_Menu.Modal.PaymentLinkConfirm": "FR: This can't be undone. Are you sure?",
    "Profile_Menu.Modal.PaymentLinkFollowUp": "FR: Follow up with your customer if you have not been notified or the policy status is set to unpaid.",
    "Profile_Menu.Modal.PaymentLinkConfirmationTitle": "FR: Payment Link Sent",
    "Profile_Menu.Modal.SuccessTitle": "FR: Success!",
    "Profile_Menu.Modal.ErrorTitle": "FR: Error!",
    "Profile_Menu.Modal.PaymentLinkSuccessMessage": "FR: A payment link has been sent to your customer to complete.",
    "Profile_Menu.Modal.PaymentLinkSuccessInfo": "FR: You will be notified by email once the payment is complete and the policy will be automatically bound.",
    "Profile_Menu.Modal.PaymentLinkLabel": "FR: Payment Link:",
    "Profile_Menu.Modal.PaymentLinkErrorMessage": "FR: We are unable to send a payment link. Please check for validation errors.",
    "Profile_Menu.Modal.PaymentLinkWindowClosedInfo1": "FR: This payment link cannot be sent because the payment would be received outside the allowed payment window.",
    "Profile_Menu.Modal.PaymentLinkWindowClosedInfo2": "FR: Please review the policy details. You can extend the payment window from the payment page if payment is still required.",
    "Profile_Menu.Modal.Ok": "FR: Ok",
    "Profile_Menu.Modal.LoseLeadTitle": "FR: Lose",
    "Profile_Menu.Modal.LoseLeadReason": "FR: Reason",
    "Profile_Menu.Modal.LoseLeadQuestion": "FR: Why didn't we win?",
    "Profile_Menu.Modal.RejectPolicyTitle": "FR: Reject Policy",
    "Profile_Menu.Modal.RejectPolicyReason": "FR: Reason",
    "Profile_Menu.Modal.RejectPolicyQuestion": "FR: Why didn't we want this lead?",
    "Profile_Menu.Modal.RejectReferralTitle": "FR: Decline",
    "Profile_Menu.Modal.RejectReferralReason": "FR: Decline Reason",
    "Profile_Menu.Modal.RejectReferralQuestion": "FR: Why are you declining this referral?",
    "Profile_Menu.Modal.AcceptReferralTitle": "FR: Accept Referral",
    "Profile_Menu.Modal.AcceptReferralOverridableErrors": "FR: Errors will be overrided",
    "Profile_Menu.Modal.EndorsementTitle": "FR: Create an Endorsement",
    "Profile_Menu.Modal.EndorsementInfo": "FR: You are about to create an Endorsement for this policy",
    "Profile_Menu.Modal.EffectiveDate": "FR: Effective Date",
    "Profile_Menu.Modal.EndorsementCreatedSuccess": "FR: Endorsement created successfully",
    "Profile_Menu.Modal.EndorsementCreatedError": "FR: Failed to create endorsement",
    "Profile_Menu.Modal.EndorsementLostError": "FR: Failed to set endorsement to lost",
    "Profile_Menu.Modal.CancelPolicyTitle": "FR: Cancel Policy",
    "Profile_Menu.Modal.CancellationDate": "FR: Cancellation Date",
    "Profile_Menu.Modal.CancellationReason": "FR: Cancellation Reason",
    "Profile_Menu.Modal.CancellationReasonQuestion": "FR: Why is this policy being cancelled?",
    "Profile_Menu.Modal.CancellationOtherReason": "FR: Please specify",
    "Profile_Menu.Modal.CancellationOtherReasonPlaceholder": "FR: Enter cancellation reason",
    "Profile_Menu.Modal.ChangeCancellationDateTitle": "FR: Change Cancellation Date",
    "Profile_Menu.Modal.Update": "FR: Update",
    "Profile_Menu.Modal.CancellationCreatedSuccess": "FR: Cancellation created",
    "Profile_Menu.Modal.CancellationCreatedError": "FR: Failed to create cancellation",
    "Profile_Menu.Modal.CancellationQuoteError": "FR: Failed to quote cancellation",
    "Profile_Menu.Modal.CancellationDeleteError": "FR: Failed to delete cancellation",
    "Profile_Menu.Modal.CancellationDateUpdateError": "FR: Failed to update cancellation date",
    "Profile_Menu.Modal.RefundTitle": "FR: Process Refund",
    "Profile_Menu.Modal.RefundAmount": "FR: Refund Amount: {amount}",
    "Profile_Menu.Modal.RefundOverrideAmount": "FR: Override Refund Amount",
    "Profile_Menu.Modal.RefundOverridePlaceholder": "FR: Enter amount",
    "Profile_Menu.Modal.Apply": "FR: Apply",
    "Profile_Menu.Modal.RefundMethod": "FR: Refund Method",
    "Profile_Menu.Modal.RefundReference": "FR: Reference",
    "Profile_Menu.Modal.RefundReferencePlaceholder": "FR: e.g. transfer reference or check number",
    "Profile_Menu.Modal.RefundDate": "FR: Refund Date",
    "Profile_Menu.Modal.CompleteRefund": "FR: Complete Refund",
    "Profile_Menu.Modal.RefundOverrideError": "FR: Failed to override refund amount",
    "Profile_Menu.Modal.RefundCompleteError": "FR: Failed to complete refund",
    "Profile_Menu.Input.EmailPlaceholder": "FR: Enter email addresses separated by comma or semicolon",
    "Profile_Menu.Input.NotePlaceholder": "FR: Enter your note here",
    "Profile_ActionsMenu.ContinueQuote": "FR: Continue Quote",
    "Profile_ActionsMenu.Abandon": "FR: Abandon",
    "Profile_ActionsMenu.Submit": "FR: Submit",
    "Profile_ActionsMenu.SendPaymentLink": "FR: Send Payment Link",
    "Profile_ActionsMenu.ChargeCard": "FR: Charge Card",
    "Profile_ActionsMenu.Recover": "FR: Recover",
    "Profile_ActionsMenu.AcceptSubmission": "FR: Accept Submission",
    "Profile_ActionsMenu.RejectSubmission": "FR: Reject Submission",
    "Profile_ActionsMenu.Lost": "FR: Lose",
    "Profile_ActionsMenu.GetQuote": "FR: Get Quote",
    "Profile_ActionsMenu.AcceptReferral": "FR: Accept Referral",
    "Profile_ActionsMenu.RejectReferral": "FR: Decline",
    "Profile_ActionsMenu.ReQuote": "FR: Re-Quote",
    "Profile_ActionsMenu.IssueQuote": "FR: Issue Quote",
    "Profile_ActionsMenu.RequestBind": "FR: Request Bind",
    "Profile_ActionsMenu.ConfirmBind": "FR: Confirm Bind",
    "Profile_ActionsMenu.Bind": "FR: Bind",
    "Profile_ActionsMenu.Issue": "FR: Issue Policy",
    "Profile_ActionsMenu.Endorse": "FR: Endorse",
    "Profile_ActionsMenu.UnderwriterReviewLink": "FR: Request UW Review",
    "Profile_ActionsMenu.Cancel": "FR: Cancel Policy",
    "Profile_ActionsMenu.CancellationQuote": "FR: Quote",
    "Profile_ActionsMenu.Refund": "FR: Refund",
    "Profile_ActionsMenu.ChangeCancellationDate": "FR: Change Cancellation Date",
    "Profile_ActionsMenu.DeleteCancellation": "FR: Delete",
    "Profile_Menu.Modal.RefundLoadError": "FR: Unable to load the refund details. Please close and try again.",
    "Profile_Menu.Modal.RefundCompleteSuccess": "FR: Refund completed successfully.",
    "Profile_Menu.Modal.RefundMethodPlaceholder": "FR: Select a refund method",
    "Profile_Menu.Modal.CancellationQuoteSuccess": "FR: Cancellation quoted successfully.",
    "Profile_Menu.Modal.CancellationDeleteSuccess": "FR: Cancellation deleted successfully.",
    "Profile_Menu.Modal.CancellationDateUpdateSuccess": "FR: Cancellation date updated successfully.",
    "Profile_Menu.Modal.DeleteCancellationTitle": "FR: Delete Cancellation",
    "Profile_Menu.Modal.DeleteCancellationConfirmation": "FR: This will delete the cancellation. This action cannot be undone.",
    "Profile_Menu.Modal.Delete": "FR: Delete"
}
